'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadExistingThread = loadExistingThread;

var _setCurrentChannel = require('../../actions/ConversationsActions/setCurrentChannel');

var _updateView = require('../../current-view/actions/updateView');

var _views = require('../../current-view/constants/views');

function loadExistingThread(_ref) {
  var channel = _ref.channel;

  return function (dispatch) {
    dispatch((0, _setCurrentChannel.setCurrentChannel)(channel));

    dispatch((0, _updateView.updateView)(_views.THREAD_VIEW));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/navigation/actions/loadExistingThread.js
// module id = 475
// module chunks = 2 3